import { __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import { default as useIsMounted } from "@pb/utils/reactHooks/useIsMounted";
import cn from 'classnames';
import PhoneInput, { isValidPhoneNumber, isPossiblePhoneNumber } from 'react-phone-number-input';
import { CountrySelectWithIcon } from 'react-phone-number-input/commonjs/CountrySelect';
import { ChevronDownIcon } from '../../Icon';
import Field from '../Field';
import styles from './PhoneNumberInput.module.scss';
const LANG_PROP_TO_LABEL_FILE_MAP = {
    en_gb: () => import('react-phone-number-input/locale/en.json'),
    ru_ru: () => import('react-phone-number-input/locale/ru.json'),
    sv_se: () => import('react-phone-number-input/locale/sv.json'),
    de_de: () => import('react-phone-number-input/locale/de.json'),
};
const CountrySelect = (_a) => {
    var { options } = _a, props = __rest(_a, ["options"]);
    const [isRendered, setIsRendered] = useState(false);
    // Postpone render of options to fix animation glitches caused by enormous amount of select options
    useEffect(() => {
        const timeout = window.setTimeout(() => {
            setIsRendered(true);
        }, 300);
        return () => {
            window.clearTimeout(timeout);
        };
    }, []);
    return (React.createElement(CountrySelectWithIcon, Object.assign({ arrowComponent: () => React.createElement(ChevronDownIcon, { className: styles.chevron }), options: isRendered ? options : [] }, props)));
};
const PhoneNumberInput = (_a) => {
    var { name, label, hint, shouldShowValidationIcon, shouldDisableValidation, disableLabel, error, onChange, value, className, disabled, required = false, defaultCountry, lang = 'en_gb', shouldValidateOnBlur, onErrorCallBack, validationFunctions, onBlurCallBack, placeholder, country, international = true, addInternationalOption = false, countries } = _a, restProps = __rest(_a, ["name", "label", "hint", "shouldShowValidationIcon", "shouldDisableValidation", "disableLabel", "error", "onChange", "value", "className", "disabled", "required", "defaultCountry", "lang", "shouldValidateOnBlur", "onErrorCallBack", "validationFunctions", "onBlurCallBack", "placeholder", "country", "international", "addInternationalOption", "countries"]);
    const [localeLabels, setLocaleLabels] = useState(undefined);
    const getIsMounted = useIsMounted();
    useEffect(() => {
        const getLocaleFile = LANG_PROP_TO_LABEL_FILE_MAP[lang];
        if (!getLocaleFile) {
            return;
        }
        getLocaleFile().then((labels) => {
            if (getIsMounted()) {
                setLocaleLabels(labels);
            }
        });
    }, [lang]);
    useEffect(() => {
        if (validationFunctions === null || validationFunctions === void 0 ? void 0 : validationFunctions.current) {
            validationFunctions.current.isValidPhoneNumber = isValidPhoneNumber;
            validationFunctions.current.isPossibleNumber = isPossiblePhoneNumber;
        }
    }, []);
    const handleChange = (newValue) => {
        if (onChange) {
            onChange(newValue);
        }
    };
    const handleBlur = (event) => {
        var _a;
        if (shouldValidateOnBlur) {
            const { value: targetValue } = (_a = event === null || event === void 0 ? void 0 : event.target) !== null && _a !== void 0 ? _a : {};
            const isValidNumber = isValidPhoneNumber(targetValue);
            const isPossibleNumber = isPossiblePhoneNumber(targetValue);
            onErrorCallBack === null || onErrorCallBack === void 0 ? void 0 : onErrorCallBack({ isValidNumber, isPossibleNumber });
        }
        onBlurCallBack === null || onBlurCallBack === void 0 ? void 0 : onBlurCallBack(event);
    };
    return (React.createElement(Field, { required: required, name: name, hint: hint, label: label, shouldDisableValidation: shouldDisableValidation, shouldShowValidationIcon: shouldShowValidationIcon, disableLabel: disableLabel, error: error, className: className, value: value, render: ({ validationStatus }) => {
            return (React.createElement("div", { className: cn(styles.wrapper, validationStatus === 'valid' && styles.valid, validationStatus === 'invalid' && styles.invalid, disabled && styles.disabled) },
                React.createElement(PhoneInput, Object.assign({ international: international, id: name, "aria-required": required, required: required, value: value, onChange: handleChange, onBlur: handleBlur, type: "tel", inputMode: "tel", countrySelectComponent: CountrySelect, defaultCountry: defaultCountry, labels: localeLabels, placeholder: placeholder, country: country, countries: countries, addInternationalOption: addInternationalOption }, restProps))));
        } }));
};
export default PhoneNumberInput;
//# sourceMappingURL=PhoneNumberInput.js.map